import { BaseDto } from 'src/dtos/common/baseDto';

/** 사원 교육훈련(hrm_training) 행과 화면 편집 상태이다. */
export interface HrmTrainingDto extends BaseDto {
    empNo: string; // 사원번호
    trainSeq: number | null; // 사원별 교육 순번, 신규는 null (서버 채번)
    trainNm: string; // 교육과정명
    trainType: string; // 교육구분 코드 (공통코드 TRAIN_TYPE)
    institution: string; // 교육기관
    startDt: string; // 교육시작일 (YYYY-MM-DD)
    endDt: string; // 교육종료일 (YYYY-MM-DD)
    trainHours: number; // 교육시간
    costAmt: number; // 교육비(원)
    refundAmt: number; // 고용보험 환급액(원)
    completeYn: string; // 이수여부 Y/N
    certNo: string; // 수료증번호
    remark: string; // 비고
    inserted: boolean; // 저장되지 않은 행이면 true
    isModified: boolean; // 조회 후 수정했으면 true
}

/** 교육훈련 신규 행의 기본값이다. 날짜는 행을 추가할 때 오늘로 덮어쓴다. */
export const defaultHrmTrainingDto: HrmTrainingDto = {
    valueIndex: 0, orderIndex: 0, orderIndexSeq: 0,
    empNo: '', trainSeq: null, trainNm: '', trainType: 'T1', institution: '',
    startDt: '', endDt: '', trainHours: 0, costAmt: 0, refundAmt: 0,
    completeYn: 'N', certNo: '', remark: '', inserted: false, isModified: false,
};
